module.exports = __webpack_public_path__ + "img/bg103_8.417a6e51.png";